import i18n from '@/i18n'
import supportedLocales from '@/locales/supportedLocales.js'

const Trans = {
    get defaultLocale() {
        return process.env.VUE_APP_I18N_LOCALE
    },
    get supportedLocales() {
        return supportedLocales
    },
    get currentLocale() {
        return i18n.global.locale.value
    },
    set currentLocale(locale) {
        i18n.global.locale.value = locale
    },
    changeLocale(locale) {
        if (!Trans.isLocaleSupported(locale)) return Promise.reject(
            new Error('Locale not supported')
        )

        if (i18n.global.locale === locale) return Promise.resolve(locale)

        return Trans.loadLocaleFile(locale).then(msgs => {
            i18n.global.setLocaleMessage(locale, msgs.default || msgs)
            return Trans.setI18nLocaleInServices(locale)
        })
    },
    isLocaleSupported(locale) {
        return Trans.supportedLocales.hasOwnProperty(locale)
    },
    loadLocaleFile(locale) {
        return import(/* webpackChunkName: "locale-[request]" */ `@/locales/${locale}.json`)
    },
    setI18nLocaleInServices(locale) {
        Trans.currentLocale = locale
        document.querySelector('html').setAttribute('lang', locale)
        return locale
    }
}

export default Trans